"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Attention = function (_a) {
    var onCloseHandler = _a.onCloseHandler, onConfirmHandler = _a.onConfirmHandler;
    var t = (0, next_intl_1.useTranslations)('translation');
    return (react_1.default.createElement(ui_components_1.Modal, { width: "480px", height: "auto", padding: "0", onClose: onCloseHandler, saveSize: true },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("img", { className: styles_module_scss_1.default.icon, src: "/img/icons/attention.svg", alt: "attention" }),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t('attention')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.description }, t('IfYouUnsubscribeAccountWillBeRemoved')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.secondaryDescription }, t('fromTheMailingListDatabase')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonsContainer },
                react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", onClick: onConfirmHandler }, t('confirm')),
                react_1.default.createElement(ui_components_1.FixedButton, { variant: "outline", color: "primary", text: "upper", onClick: onCloseHandler }, t('cancel'))))));
};
exports.default = Attention;
